(function () {
  function getMinQty() {
    const el = document.getElementById("MinQtyData");
    if (!el) return 1;
    try {
      const n = JSON.parse(el.textContent);
      const v = parseInt(n, 10);
      return Number.isFinite(v) && v > 0 ? v : 1;
    } catch {
      return 1;
    }
  }

  function ensureMessageNode(qtyInput) {
    let msg = document.getElementById("MinQtyMessage");
    if (msg) return msg;

    msg = document.createElement("div");
    msg.id = "MinQtyMessage";
    msg.style.marginTop = "8px";
    msg.style.fontSize = "0.9rem";
    msg.style.display = "none";

    // Insert right after the quantity input container if possible
    const wrapper = qtyInput.closest(".quantity") || qtyInput.parentElement;
    wrapper.insertAdjacentElement("afterend", msg);
    return msg;
  }

  function showMsg(msgEl, text) {
    msgEl.textContent = text;
    msgEl.style.display = "block";
  }

  function hideMsg(msgEl) {
    msgEl.textContent = "";
    msgEl.style.display = "none";
  }

  document.addEventListener("DOMContentLoaded", function () {
    const minQty = getMinQty();
    if (!minQty || minQty <= 1) return;

    const productForm =
      document.querySelector("product-form form") ||
      document.querySelector('form[action^="/cart/add"]');

    const qtyInput =
      document.querySelector('input[name="quantity"]') ||
      (productForm ? productForm.querySelector('input[name="quantity"]') : null);

    if (!productForm || !qtyInput) return;

    const msgEl = ensureMessageNode(qtyInput);

    function clamp() {
      const current = parseInt(qtyInput.value, 10) || 1;
      if (current < minQty) {
        qtyInput.value = String(minQty);
        showMsg(msgEl, `Minimum order is ${minQty}.`);
      } else {
        hideMsg(msgEl);
      }
    }

    // Force starting value to at least min
    clamp();

    // When user types or uses +/- controls
    qtyInput.addEventListener("change", clamp);
    qtyInput.addEventListener("input", function () {
      // Don’t aggressively overwrite while typing single digits — only enforce when they leave field
      hideMsg(msgEl);
    });

    // Block add-to-cart if below min
    productForm.addEventListener("submit", function (e) {
      const current = parseInt(qtyInput.value, 10) || 1;
      if (current < minQty) {
        e.preventDefault();
        qtyInput.value = String(minQty);
        showMsg(msgEl, `Minimum order is ${minQty}. Quantity has been set to ${minQty}.`);
        qtyInput.focus();
      }
    });
  });
})();

(function () {
  function getMinQtyFromInput(qtyInput) {
    // tries: data-min-js (your attribute), then min attribute
    const a = parseInt(qtyInput.getAttribute("data-min-js"), 10);
    if (!isNaN(a) && a > 0) return a;

    const b = parseInt(qtyInput.getAttribute("min"), 10);
    if (!isNaN(b) && b > 0) return b;

    return 1;
  }

  function clampQty(qtyInput) {
    const minQty = getMinQtyFromInput(qtyInput);
    const current = parseInt(qtyInput.value, 10);

    if (isNaN(current) || current < minQty) {
      qtyInput.value = String(minQty);
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function attachToContainer(container) {
    if (!container) return;

    const qtyInputs = container.querySelectorAll('input[name="quantity"]');
    qtyInputs.forEach((qtyInput) => {
      // On load
      clampQty(qtyInput);

      // When user types
      qtyInput.addEventListener("input", () => clampQty(qtyInput));
      qtyInput.addEventListener("change", () => clampQty(qtyInput));

      // When + / - buttons are clicked
      const wrapper = qtyInput.closest("quantity-input") || qtyInput.parentElement;
      if (wrapper) {
        wrapper.addEventListener("click", (e) => {
          const btn = e.target.closest('button[name="plus"], button[name="minus"]');
          if (!btn) return;

          // Let Shopify update the value first, then clamp
          setTimeout(() => clampQty(qtyInput), 0);
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    attachToContainer(document);

    // In case theme swaps the product section on variant change
    const obs = new MutationObserver(() => attachToContainer(document));
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();